import { Outlet } from "react-router-dom";
import { useState, useEffect } from "react";
import useRefreshToken from '../../hooks/useRefreshToken';
import useAuth from '../../hooks/useAuth';
import useLocalStorage from "../../hooks/useLocalStorage";
import LoadingSpinner from "../loadingSpinner/LoadingSpinner";
import { axiosPrivate } from "../../api/axios";
import { getIsLoggingOut } from "../../hooks/useLogout";

const PersistLogin = () => {
    const [isLoading, setIsLoading] = useState(true);
    const refresh = useRefreshToken();
    const { auth, setAuth, authLoaded, setAuthLoaded } = useAuth();
    const [persist] = useLocalStorage('persist', false);

    useEffect(() => {
        let isMounted = true;

        const verifyRefreshToken = async () => {
            try {
                await refresh();
            } catch (err) {
                if (err?.response?.status === 401) {
                    console.warn('No valid refresh token — user not logged in.');
                }
            } finally {
                if (isMounted) {
                    setAuthLoaded(true);   // ✅ lifecycle only
                    setIsLoading(false);
                }
            }
        };

        if (!auth?.accessToken && persist) {
            verifyRefreshToken();
        } else {
            setAuthLoaded(true);          // ✅ lifecycle only
            setIsLoading(false);
        }

        return () => {
            isMounted = false;
        };
    }, [auth?.accessToken, persist]);

    // Terms check — now correctly gated
    useEffect(() => {
        if (!authLoaded) return;
        if (!auth?.userId) return;
        if (auth.termsAcceptedAt !== undefined) return;

        const checkTerms = async () => {
            try {
                const res = await axiosPrivate.get('/legal/check');
                setAuth(prev => ({
                    ...prev,
                    termsAcceptedAt: res.data.acceptedAt
                }));
            } catch (err) {
                console.error("Failed to check terms acceptance", err);
            }
        };

        checkTerms();
    }, [authLoaded, auth?.userId]);

    if (!persist) return <Outlet />;

    return isLoading ? <LoadingSpinner /> : <Outlet />;
};


export default PersistLogin